export default {"src":"/_next/static/media/time.5e6343f8.svg","height":106,"width":106,"blurWidth":0,"blurHeight":0};